import {LOAD_ERRORS, MARK_ERROR_AS_SHOWN} from '../actions/types';

const initialState = {
    errors:[],
    showed:false,
}

export default function(state=initialState, action){
    switch(action.type){
        case LOAD_ERRORS:
            return {
                ...state,
                errors:action.payload,
                showed:false
            };
        case MARK_ERROR_AS_SHOWN:
            return {
                ...state,
                showed:true,
            }
        default:
            return state;
    }
}